export default {
  GET_LEAVE_STATUS: {
    url: '/leave/leave/leaveStatus'
  },
  GET_ALL_LEAVE_GROUP: {
    url: '/leave/leaveGroup'
  },
  GET_LEAVE_GROUP: {
    url: '/leave/leaveGroup/'
  },
  CREATE_LEAVE_GROUP: {
    url: '/leave/leaveGroup',
    method: 'POST'
  },
  UPDATE_LEAVE_GROUP: {
    url: '/leave/leaveGroup/',
    method: 'PUT'
  },
  DELETE_LEAVE_GROUP: {
    url: '/leave/leaveGroup',
    method: 'DELETE'
  },
  GET_LEAVE_REPORT_SETTING: {
    url: '/leave/leaveReportSetting/',
    method: 'GET'
  },
  UPDATE_LEAVE_REPORT_SETTING: {
    url: '/leave/leaveReportSetting/',
    method: 'PUT'
  },
  GET_APPROVAL_BY_ID: {
    url: '/leave/leaveTx/getApprovalById',
    method: 'POST'
  },
  SEARCH_APPROVAL_LIST: {
    url: '/leave/leaveTx/getApproval',
    method: 'POST'
  },
  GET_TRANSACTION_HISTORY_LIST: {
    url: '/leave/leaveTx/report/',
    method: 'POST'
  },
  CREATE_DELEGATES: {
    url: '/leave/delegate/',
    method: 'POST'
  },
  UPDATE_DELEGATES: {
    url: '/leave/delegate/',
    method: 'PUT'
  },
  DELETE_DELEGATES: {
    url: '/leave/delegate/',
    method: 'DELETE'
  },
  GET_DELEGATES: {
    url: '/leave/delegate/'
  },
  GET_ALL_DELEGATES: {
    url: '/leave/delegate/'
  },
  GET_EFFECTIVE_DELEGATE_CONTEXTS: {
    url: '/leave/delegate/effective-contexts'
  },
  GET_ADMIN_COMPANY_CONTEXT: {
    url: '/leave/admin-context/company/'
  },
  GET_REQUESTER_ATTACHMENT_URL: {
    url: '/leave/leaveTx/',
    method: 'POST'
  },
  GET_APPROVER_ATTACHMENT_URL: {
    url: '/leave/leaveTx/',
    method: 'POST'
  },
  POST_LEAVE_TRANSACTION: {
    url: '/leave/leaveTx/report',
    method: 'POST'
  },
  EXPORT_LEAVE_TRANSACTION: {
    url: '/leave/leaveTx/report/excel',
    method: 'POST'
  },

  EXPORT_LEAVE_SUMMARY: {
    url: '/leave/leaveSummary/report/excel',
    method: 'POST'
  },
  GET_ENTITLEMENT: {
    url: '/leave/leaveSummary/entitlement',
    method: 'GET'
  },
  HOUR_PREVIEW: {
    url: '/leave/leaveTx/hour-preview',
    method: 'POST'
  },
  CREATE_LEAVETX: {
    url: '/leave/leaveTx/',
    method: 'POST',
    isMultipart: true,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  },
  POST_APPROVAL: {
    url: '/leave/leaveTx/approval',
    method: 'POST'
  },
  GET_LEAVE_TX_BY_PIS_ID: {
    url: '/leave/leaveTx/pisId/',
    method: 'GET'
  },
  GET_LEAVE_TX: {
    url: '/leave/leaveTx/',
    method: 'GET'
  },
  EDIT_LEAVETX: {
    url: '/leave/leaveTx/',
    method: 'PUT',
    isMultipart: true,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  },
  POST_CANCEL_TX: {
    url: '/leave/leaveTx/cancel/',
    method: 'POST'
  },
  POST_RESEND_TX: {
    url: '/leave/leaveTx/resendEmail/',
    method: 'POST'
  },
  GET_EMPLOYEE_INFORMATION: {
    url: '/leave/employeeInformationSetting/'
  },
  UPDATE_EMPLOYEE_INFORMATION: {
    url: '/leave/employeeInformationSetting/',
    method: 'PUT'
  },
  GET_LEAVE_PERIOD: {
    url: '/leave/leavePeriod/'
  },
  CREATE_LEAVE_PERIOD: {
    url: '/leave/leavePeriod',
    method: 'POST'
  },
  UPDATE_LEAVE_PERIOD: {
    url: '/leave/leavePeriod/action',
    method: 'POST'
  },
  SEARCH_LEAVE_SUMMARY: {
    url: '/leave/leaveSummary/',
    method: 'POST'
  },
  LEAVE_SUMMARY_REPORT_EXCEL: {
    url: '/leave/leaveSummary/report/excel',
    method: 'POST'
  },
  EDIT_LEAVE_SUMMARY: {
    url: '/leave/leaveSummary/',
    method: 'PUT'
  },
  SEARCH_LEAVE_TYPE: {
    url: '/leave/leavetype'
  },
  APPROVE_EMAIL_LEAVETX: {
    url: '/leave/leaveTx/approval/email',
    method: 'POST'
  },
  IMPORT_LEAVE_TX: {
    url: '/leave/leave-import',
    method: 'POST',
    isPublic: false,
    isMultipart: true,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  },
  GET_IMPORT_FILE_RESULT: {
    url: '/leave/leave-import/result',
    method: 'GET',
    isPublic: false
  },
  GET_APPROVER_INFORMATION: {
    url: '/leave/information/leave-req/approver',
    method: 'GET',
    isPublic: false
  },
  DOWNLOAD_LEAVE_EXPORT: {
    url: '/leave/export/download',
    method: 'GET',
    isPublic: false,
    isBlob: true
  },
  COMPLETE_LEAVE_EXPORT_DOWNLOAD: {
    url: '/leave/export/download-complete',
    method: 'POST',
    isPublic: false
  },
  GET_LEAVE_EXPORT_FILES: {
    url: '/leave/export/get-list',
    method: 'GET',
    isPublic: false
  },
  EXPORT_LEAVE_FILE: {
    url: '/leave/export',
    method: 'POST',
    isPublic: false
  },
  GET_LEAVE_EXPORT_STATUS: {
    url: '/leave/export/status',
    method: 'GET',
    isPublic: false
  },
  GET_LEAVE_EXPORT_OPTIONS: {
    url: '/leave/export/options',
    method: 'GET',
    isPublic: false
  }
}
